import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Certificate2Service} from '../services/certificate2.service';
import {ContextService} from '../services/context.service';
import {SubscriptionsService} from 'src/app/services/subscriptions.service';
import {EnrollmentService} from '../services/enrollment.service';
import {MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {EventService} from '../services/event.service';
import {SpinnerService} from '../shared/waiting/spinner.service';
import {CertificatesSubscriptionsDialogComponent} from './dialogs/certificates-subscriptions-dialog/certificates-subscriptions-dialog.component';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {ConfirmComponent} from '../shared/dialogs/confirm/confirm.component';

@Component({
  selector: 'app-certificates-subscriptions',
  templateUrl: './certificates-subscriptions.component.html',
  styleUrls: [ './certificates-subscriptions.component.scss' ]
})
export class CertificatesSubscriptionsComponent implements OnInit {

  public isCongress = false;
  public context_id: any;
  public title: any;

  public subscriptionDataSource: MatTableDataSource<any>
  public displayedCertificateColumns: string[] = [ 'icon', 'member_name', 'product_name', 'view', 'selected' ];

  public waiting: any;

  //public arrayCertificate: any[] = []
  public eventsWithCertificatesInContext: any[] = [];
  public selectedEvent: any = null;

  public arrayEvents: any[] = []

  public enrollments: any = [];

  public master: any;
  public event: any;


  constructor (
    public _eventService: EventService,
    private _activeRoute: ActivatedRoute,
    public _certificateService: Certificate2Service,
    private _contextService: ContextService,
    public _subscriptionsService: SubscriptionsService,
    private _enrollmentService: EnrollmentService,
    private _spinnerService: SpinnerService,
    private _snackBar: SnackBarIconService,
    private _dialog: MatDialog,

  ) { }

  ngOnInit () {
    this._activeRoute.params.subscribe(params => {
      this.isCongress = params[ 'isCongress' ] === 'true';
      this.context_id = params[ 'uid' ];
      // console.log("context_id: " + this.context_id)
      this.selectContext()
    })
  }

  applyFilter (filterValue: string) {
    this.subscriptionDataSource.filter = filterValue.trim().toLowerCase();
  }

  async selectContext () {
    const waiting = this._spinnerService.show();

    if (this.isCongress) {
      this.master = await this._contextService.getMasterEvent(this.context_id);
      this.title = this.master.name;
      this.eventsWithCertificatesInContext = await this._contextService.getEventsWithCertificatesInContext(this.context_id)
    } else {
      this.event = await this._contextService.getEvent(this.context_id);
      this.title = this.event.name;
      this.eventsWithCertificatesInContext.push({"id": this.event.id, "name": this.event.name})
    }

    this.arrayEvents = await this._contextService.selectProductsByEvents(this.eventsWithCertificatesInContext);

    console.log("this.arrayEvents: " + JSON.stringify(this.arrayEvents))
    waiting.close();
  }

  async eventChange (param: any) {
    //
    console.log("eventChange")

    const waiting = this._spinnerService.show();

    this.selectedEvent = param;

    this.enrollments = await this._enrollmentService.selectByEvent(this.selectedEvent.id)
    //console.log("this.enrollments: " + JSON.stringify(this.enrollments));
    const subscriptions = await this._subscriptionsService.getOrdersByProducts(this.selectedEvent.products)
    //console.log("subscriptions: " + JSON.stringify(subscriptions));
    const certificates = await this.processSubscription(subscriptions, this.enrollments)
    //console.log("certificates: " + JSON.stringify(certificates));

    this.subscriptionDataSource = null;
    this.subscriptionDataSource = new MatTableDataSource(certificates);

    waiting.close();

  }

  async processSubscription (subscriptions: any[], enrollments: any[]) {
    //console.log("subscriptions: " + JSON.stringify(subscriptions))
    const arrayCertificate: any[] = []

    subscriptions.forEach((subscription) => {

      let enroll = enrollments.find((e) => {
        return e.member_id == subscription.member_id && e.type == 'participante';
      })

      let selected: boolean = false;
      let certificateURL: any;
      if (enroll) {
        //console.log("enroll: " + JSON.stringify(enroll))
        selected = true
        certificateURL = enroll.certificate_url.length > 0 ? enroll.certificate_url : null
      }

      arrayCertificate.push({
        "enroll_id": enroll ? enroll.id : '',
        "event_id": this.selectedEvent.id,
        "event_name": this.selectedEvent.name,
        "products": subscription.product_id,
        "member_name": subscription.member_name,
        "member_email": subscription.member_email,
        "member_id": subscription.member_id,
        "topic_id": subscription.topic_id || '',
        "topic_name": subscription.topic_name || '',
        "text1": subscription.topic_text1 || '',
        "text2": subscription.topic_text2 || '',
        "text3": subscription.topic_text3 || '',
        "certificate_url": certificateURL,
        "selected": selected
      });

    })

    return arrayCertificate;
  }

  openCertificateConfigDialog () {
    let data = {};

    if (this.isCongress) {
      data = {
        //"id": this.master.id,
        //"name": this.master.name,
        "event_id": this.selectedEvent.id,
        "event_name": this.selectedEvent.name,
        "isCongress": this.isCongress,
        "products": this.selectedEvent.products,
      }
    } else {
      data = {
        //"id": this.event.id,
        //"name": this.event.name,
        "event_id": this.selectedEvent.id,
        "event_name": this.selectedEvent.name,
        "isCongress": this.isCongress,
        "products": this.selectedEvent.products,
      }
    }

    let dialogRef = this._dialog.open(CertificatesSubscriptionsDialogComponent, {
      width: '920px',
      height: '630px',
      panelClass: 'custom-dialog-container',
      data: data
    });

    dialogRef.afterClosed()
      .subscribe(async (response) => {
        if (!response) {
          return;
        }

        const actionType: string = response[ 0 ];

        if (actionType == 'ok') {

          const form: any = response[ 1 ];
          const objectImage: string = response[ 2 ];
          const formData = form.getRawValue();

          console.log("data: " + JSON.stringify(data));
          console.log("objectImage: " + objectImage);
          console.log("formData: " + JSON.stringify(formData));

          const entity = {
            "id": formData.event_id,
            "name": formData.event_name,
            "isCongress": formData.isCongress,
            "user_role": formData.user_role,
            "user_qrCode": formData.user_qrCode,
            "user_image_url": formData.user_image_url
          }

          console.log("entity: " + JSON.stringify(entity));
          
          await this._certificateService.updateConfig(entity)
            .then(async () => {

              if (objectImage) {
                await this._certificateService.uploadImage(objectImage, entity.id, "user_")
                  .then(() => {
                    // console.log("uploadImage result: " + JSON.stringify(result))
                  })
                  .catch(() => {
                    console.log("uploadImage error: ");
                  })
              }

            })
          
        }


      })
  }

  async updateSubscriptionEnrollments () {
    let array = this.subscriptionDataSource.data

    for (const item of array) {
      let existInEnrollments = this.enrollments.find((e: any) => {
        return e.member_id == item.member_id && e.type == 'participante';
      })

      if (item.selected && !existInEnrollments) {

        // insert in enrollments
        let enrollment: any = {
          created: new Date(),
          finished: true,
          type: "participante",
          certificate_url: "",

          member_id: item.member_id,
          member_name: item.member_name,

          event_id: item.event_id,
          event_name: item.event_name,
          topic_id: item.topic_id,
          topic_name: item.topic_name,
          topic_text1: item.text1 || '',
          topic_text2: item.text2 || '',
          topic_text3: item.text3 || '',
        }

        // console.log("insert: " + JSON.stringify(enrollment))

        await this._enrollmentService.insert(enrollment)
          .then(async (e) => {
            // this._snackBar.openSnackBar("Sucesso!", '', 'success');
          })
          .catch((error) => {
            console.log("insert erro: " + JSON.stringify(error))
            // this._snackBar.openSnackBar("Erro", '', 'error');
          })

      } else if (!item.selected && existInEnrollments) {

        //  console.log("remove: " + JSON.stringify(item))

        await this._enrollmentService.remove(item.enroll_id)
          .then(
            async () => {
              console.log("removed: " + item.enroll_id)
            }
          )
          .catch(
            (error) => {console.log("delete enroll error: " + error.message)}
          )

      }

    }

    // console.log("this.eventChange")
    this.eventChange(this.selectedEvent)
  }


  removeEnroll (element) {
    console.log(element.enroll_id)

    let dialogRef = this._dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.event_name + "<br>" + element.member_name + "<br><br>Excluir este certificado?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._enrollmentService.remove(element.enroll_id)
          .then(
            () => {
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            () => {console.log("delete enroll error: ")}
          )
      }
    })
  }

  toggleCheckUsers (flag) {
    this.subscriptionDataSource.data.forEach((item) => {
      item.selected = flag;
    })
  }

}
